import React from 'react';
import SapFieldglassContent from '../function-components/SapFieldglass/SapFieldglassContent';

const SapFieldglass = () => {
  return (
    <SapFieldglassContent />
  )
}

export default SapFieldglass